import {defineStore} from "pinia";
import {useApplicationStore} from "@/store/application_2";
import Api from "@/api/Api";
import Cookies from "@/cookies";

const url = {
  campaign: '/users/getCampaign',
}

export const useCampaignStore = defineStore('campaign', {
  state: () => ({
    isActive: false,
    isModalClosed: false,
    isActiveBanner: false,
    filename: 'rabbithole',
    campaign: {
      title: {
        es: "",
        en: "",
      },
      description: {
        es: "",
        en: "",
      }
    },
    banners: {
      color: "#FF5733",
      title: {
        es: "asd",
        en: "aasd",
      },
      description: {
        es: "asd",
        en: "asd",

      }
    }
  }),
  getters: {
    shouldShowModal() {
      const cookieName = this.filename
      const cookie = Cookies.get(cookieName) || false
      const {load} = useApplicationStore()
      return this.isActive && !load && !this.isModalClosed && !cookie;
    }
  },
  actions: {
    async getCampaign() {
      const {error, data} = await Api.get(url.campaign)
      if (!error) {
        const campaign = data
        this.campaign = campaign
        this.filename = campaign.payload.filename
        this.banners = campaign.payload.banners
        this.isActiveBanner = campaign.active
        this.isActive = campaign.active
      } else {
        this.isActive = true
      }
    },
    closeModal() {
      this.isModalClosed = true;
    },
    notShow() {
      const cookieModal = this.filename
      Cookies.set(cookieModal, true)
      this.closeModal()
    }
  }
});
